import { DecimalPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { TranslatePipe } from '@next/core-lib/i18n';

import { DairyYieldScanCategoryPotential } from '../../models/dairy-yield-scan.models';

const CATEGORY_LABEL_KEYS = new Map<string, string>([
  ['dairyYieldScan.categories.rantsoen', 'dairyYieldScan.summary.categoryLabels.nutrition'],
  [
    'dairyYieldScan.categories.managementEnConsistentie',
    'dairyYieldScan.summary.categoryLabels.management',
  ],
  [
    'dairyYieldScan.categories.huisvestingComfortenStress',
    'dairyYieldScan.summary.categoryLabels.housing',
  ],
]);

@Component({
  selector: 'app-dairy-yield-scan-category-potentials',
  templateUrl: './dairy-yield-scan-category-potentials.component.html',
  styleUrls: ['./dairy-yield-scan-category-potentials.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [DecimalPipe, MatIconModule, TranslatePipe],
})
export class DairyYieldScanCategoryPotentialsComponent {
  @Input({ required: true }) categoryPotentials: readonly DairyYieldScanCategoryPotential[] = [];

  categoryLabelKey(category: string): string {
    return CATEGORY_LABEL_KEYS.get(category) ?? category;
  }

  isLeadingCategory(potential: number): boolean {
    return this.highestPotential() > 0 && potential === this.highestPotential();
  }

  categoryBarWidth(potential: number): number {
    const highestPotential = this.highestPotential();
    return highestPotential === 0
      ? 0
      : Math.min(100, Math.max(0, potential / highestPotential) * 100);
  }

  private highestPotential(): number {
    return Math.max(0, ...this.categoryPotentials.map((category) => category.potential));
  }
}
